import JWPlayerComponent from './JWPlayer';
export default JWPlayerComponent;